import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-delect-modal',
  templateUrl: './delect-modal.component.html',
  styleUrls: ['./delect-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DelectModalComponent implements OnInit {
  @Input() display: boolean =  false;
  @Input() bigTitle: string = 'jiaoyu';
  @Input() bodyContant: string = "dafedg";

  @Output() isDisplay: any = new EventEmitter();
  @Output() isDelete: any = new EventEmitter();


  constructor() { }

  ngOnInit() {

  }

  targetDialog() {
    this.isDisplay.emit(this.display);
  }

  //删除
  delectData(){
    this.isDelete.emit(true);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/delect-modal/delect-modal.component.ts